import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import type { iMultiChannelCampaignVariableConfig } from "@sdk/chat-widgets/chat-widgets.models";
import React from "react";

const ManageMultiChannelVariablesModal = React.lazy(
  () => import("./manage-multi-channel-variables.modal"),
);

const ManageMultiChannelVariables: iModalProps<
  typeof ManageMultiChannelVariablesModal,
  {
    initialVariables?: iMultiChannelCampaignVariableConfig[];
    onSave: (variables: iMultiChannelCampaignVariableConfig[]) => void;
  }
> = {
  name: "manage-multi-channel-variables",
  component: GenerateModalWithSuspense(ManageMultiChannelVariablesModal),
};

export default ManageMultiChannelVariables;
